import React from 'react'
import { InputNumber, Input, Checkbox } from 'antd';


const GetInput = (props) => {

    const { onChange } = props
    const InputNumberOnChange = (e, rowid, name) => {
        //console.log(`what is the id: ${id} ${name}`)

        const target = {
            name,
            rowid,
            value: e

        }
        onChange(target)
    }

    //console.log('GetInput: ' + props)
    if (props.name === 'sortOrder') {
        //let  props = {...props, onChange: InputNumberOnChange}
        //onChange = InputNumberOnChange    


        return <InputNumber   {...props} onChange={(e) => InputNumberOnChange(e, props.rowid, props.name)} />
    }

    if (props.name === "active") {
        //console.log("checkbox default value:" + props.value)
        return <Checkbox checked={props.value} {...props} ></Checkbox>
    }
    return <Input  {...props}  ></Input>
}

class EditableCell extends React.Component {

    render() {
        return (
            <td>
                <GetInput name={this.props.cellData.type}
                    rowid={this.props.cellData.rowid.toString()}
                    value={this.props.cellData.value}
                    onChange={this.props.onTableUpdate} />

                {/* {this.getInput( name:{this.props.cellData.type},
          id={this.props.cellData.id}, 
          defaultValue={this.props.cellData.value}, 
          onChange={this.props.onTableUpdate})
            } */}
            </td>
        );

    }

}

export default EditableCell